import htmlImg from '../../assets/skills/html.svg';
import cssImg from '../../assets/skills/css.svg';
import javascriptImg from '../../assets/skills/javascript.svg';
import reactImg from '../../assets/skills/react.svg';
import bootstrapImg from '../../assets/skills/bootstrap.svg';
import figmaImg from '../../assets/skills/figma.svg';
import sassImg from '../../assets/skills/sass.svg';
import tailwindImg from '../../assets/skills/tailwind.svg';
import gitImg from '../../assets/skills/git.svg';
import nextImg from '../../assets/skills/nextjs.svg';
import styledcomponentImg from '../../assets/skills/styledcomponents.svg';
import typescript from '../../assets/skills/typescript.svg'
import node from '../../assets/skills/nodejs.svg'

export const mySkills = [
  {
    id: 1,
    name: "HTML",
    image: htmlImg
  },

  {
    id: 2,
    name: "CSS",
    image: cssImg
  },

  {
    id: 3,
    name: "JavaScript",
    image: javascriptImg
  },

  {
    id: 101,
    name: "TypeScript",
    image: typescript
  },

  {
    id: 111,
    name: "NodeJS",
    image: node
  },

  {
    id: 4,
    name: "React",
    image: reactImg
  },

  {
    id: 11,
    name: "Next JS",
    image: nextImg
  },

  {
    id: 5,
    name: "Bootstrap",
    image: bootstrapImg
  },

  {
    id: 6,
    name: "Figma",
    image: figmaImg
  },

  {
    id: 7,
    name: "Sass",
    image: sassImg
  }, 

  {
    id:8,
    name: "Tailwind",
    image: tailwindImg
  },

  {
    id: 9,
    name: "Git",
    image: gitImg,
  },

  {
    id: 10,
    name: "styled-components",
    image: styledcomponentImg
  },
]